import { useState } from "react";

import { useQuery } from "@tanstack/react-query";

import { ReactQueryKeys } from "../services/ReactQueryKeys.ts";
import { useSenderService } from "../services/useSenderService.ts";

export function useSenders(page: number, selectedStatuses: string[]) {
  const { fetchSenders } = useSenderService();
  const [statuses, setStatuses] = useState(selectedStatuses);
  const queryKey = [ReactQueryKeys.SENDERS, page, statuses];

  const fetchSendersPage = async () => {
    return await fetchSenders(page, statuses);
  };

  const {
    data,
    error: queryError,
    isError,
    isLoading
  } = useQuery({
    queryKey: queryKey,
    queryFn: fetchSendersPage
  });

  return {
    senders: data,
    isLoading,
    queryError,
    isError,
    setStatuses,
    statuses
  };
}
